import React, { useState } from "react";
import { GoCopy, GoCheck } from "react-icons/go";
import {
  BsHandThumbsUp,
  BsFillHandThumbsUpFill,
  BsHandThumbsDown,
  BsFillHandThumbsDownFill,
} from "react-icons/bs";
import axios from "axios";

const QuesResponseComponent = (props) => {
  const [showTick, setShowTick] = useState(false);
  console.log(props.tracking_id);
  const [selectedOption, setSelectedOption] = useState(null);

  const copyToClipboard = async () => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(props.content, "text/html");
    var textContent = doc.body.textContent || "";
    reactionAPI("Copy");
    try {
      await navigator.clipboard.writeText(textContent);
      setShowTick(true);
      setTimeout(() => {
        setShowTick(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  };

  const reactionAPI = async (input) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API}api/gptaction`,
        {
          action: input,
          tracking_id: props.tracking_id,
        },
        {
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleOptionClick = (option) => {
    reactionAPI(option);
    if (selectedOption === option) {
      setSelectedOption(null);
    } else {
      setSelectedOption(option);
    }
  };

  return (
    <div className="flex items-start justify-start flex-col md:max-w-[50%] max-w-[80%] md:mt-2 mt-1">
      <div
        className={`flex flex-col rounded-t-lg bg-[#f7f9fd] text-black max-w-[100%]  box-border  pl-1`}
      >
        <p
          className="bulletPointUL leading-6 md:mx-2 mx-0 my-1 md:py-1 pb-1 px-1 md:text-[16px] text-sm font-montserrat"
          dangerouslySetInnerHTML={{ __html: props.content }}
        ></p>
        <div className="flex gap-2 md:ml-4 ml-1 md:pb-3 pb-2 self-end pt-3 pr-4 ">
          {showTick ? (
            <GoCheck size={17} color="#1543cd" />
          ) : (
            <GoCopy
              size={17}
              color="#1543cd"
              className="cursor-pointer"
              onClick={copyToClipboard}
            />
          )}

          <div
            className={`cursor-pointer ${
              selectedOption === "thumbsUp" ? "text-blue-500" : ""
            }`}
          >
            {selectedOption === "thumbsUp" ? (
              <BsFillHandThumbsUpFill
                size={17}
                color="#1543cd"
                onClick={() => handleOptionClick("thumbsUp-")}
              />
            ) : (
              <BsHandThumbsUp
                size={17}
                color="#1543cd"
                onClick={() => handleOptionClick("thumbsUp")}
              />
            )}
          </div>

          <div
            className={`cursor-pointer ${
              selectedOption === "thumbsDown" ? "text-blue-500" : ""
            }`}
          >
            {selectedOption === "thumbsDown" ? (
              <BsFillHandThumbsDownFill
                size={17}
                color="#1543cd"
                onClick={() => handleOptionClick("thumbsDown-")}
              />
            ) : (
              <BsHandThumbsDown
                size={17}
                color="#1543cd"
                onClick={() => handleOptionClick("thumbsDown")}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuesResponseComponent;
